/**
 * Bucket a flat `SelfSlot[]` into a `DaySlotMap` keyed by `dateKey`.
 * Keeps slot order stable (insertion order == chronological order
 * because upstream stages always cursor-forward).
 */
import type { DaySlotMap, SelfSlot } from '../types';

export function groupByDay(slots: SelfSlot[]): DaySlotMap {
  const out: DaySlotMap = {};
  for (const slot of slots) {
    if (!out[slot.dateKey]) out[slot.dateKey] = [];
    out[slot.dateKey]!.push(slot);
  }
  return out;
}
